/***
 * 创建人：zll
 * 时间：2021-10-28
 * 描述：对港澳台通行证进行验证
 * 更新记录: 
 */
import { Directive} from "@angular/core"
import { Validator, AbstractControl, NG_VALIDATORS} from "@angular/forms"

@Directive({
  selector:"[validatorHktwcard]",
  providers:[{
    provide:NG_VALIDATORS,
    useExisting:ValidatorHktwcardDirective,
    multi:true
  }]
})
export class ValidatorHktwcardDirective implements Validator{
  constructor(){

  }
  validate(control:AbstractControl):{[property:string]:string}{
     // 港澳居民来往内地通行证
     // 规则： H/M + 10位或6位数字
     // 样本： H1234567890
      let regHK=/^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
      // 台湾居民来往大陆通行证
      // 规则： 新版8位或18位数字， 旧版10位数字 + 英文字母
      // 样本： 12345678 或 1234567890B
      let regTW= /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
      //输入框的值
      let idcard=control.value;

      //为空时不验证
      if(!idcard || idcard==""){
        return null
      }
      if(regHK.test(idcard) || regTW.test(idcard)){
         return null
      }else{
         return {validatorHktwcard:"通行证格式不匹配"}
      }
  }
}